import React, { useState } from "react";

export default function Warehousing() {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;

    setTimeout(() => {
      setLoading(false);
      setDone(true);
      form.reset();
      setTimeout(() => setDone(false), 3000);
    }, 1500);
  };

  return (
    <>
      {/* ⭐ INLINE CSS */}
      <style>{`
        .banner {
          height: 350px;
          background: url('/slider4.jpg') center/cover no-repeat;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
          color: white;
        }

        .banner::after {
          content: "";
          position: absolute;
          inset: 0;
          background: rgba(0,0,0,0.55);
        }

        .banner h1 {
          z-index: 2;
          font-size: 50px;
          font-weight: 800;
        }

        .section {
          padding: 90px 0;
        }

        .glass-card {
          background: rgba(255,255,255,0.9);
          padding: 45px;
          border-radius: 22px;
          box-shadow: 0 12px 35px rgba(0,0,0,0.12);
          backdrop-filter: blur(12px);
          animation: fadeUp 1s ease;
          border: 1px solid rgba(0,0,0,0.08);
          margin-bottom: 60px;
        }

        .title {
          font-weight: 800;
          font-size: 34px;
          margin-bottom: 20px;
          position: relative;
        }

        .title::after {
          content: "";
          width: 100px;
          height: 5px;
          background: linear-gradient(90deg, #005eff, #f80b0b);
          position: absolute;
          bottom: -8px;
          left: 0;
          border-radius: 5px;
        }

        .text {
          font-size: 17px;
          color: #444;
          line-height: 1.9;
          margin-bottom: 18px;
        }

        .feature-box {
          padding: 25px;
          border-radius: 18px;
          background: white;
          border-left: 6px solid #005eff;
          box-shadow: 0px 10px 25px rgba(0,0,0,0.12);
          margin-bottom: 22px;
        }

        .warehouse-form {
          margin-top: 70px;
          background: white;
          padding: 45px;
          border-radius: 22px;
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0px 18px 40px rgba(0,0,0,0.12);
          animation: fadeUp 1s ease;
        }

        .form-label {
          font-weight: 600;
          margin-bottom: 7px;
          color: #222;
        }

        .form-control-custom,
        .form-select-custom {
          width: 100%;
          padding: 14px;
          border-radius: 12px;
          border: 1px solid #cfd6ff;
          font-size: 15px;
          transition: .25s ease;
        }

        .form-control-custom:focus,
        .form-select-custom:focus {
          border-color: #005eff;
          box-shadow: 0 0 8px rgba(0,94,255,0.35);
          outline: none;
        }

        .submit-btn {
          width: 100%;
          padding: 16px;
          background: linear-gradient(90deg, #005eff, #003fc8);
          border: none;
          color: #fff;
          font-size: 18px;
          font-weight: 700;
          border-radius: 14px;
          transition: .3s ease;
        }

        .submit-btn:hover {
          transform: translateY(-3px);
          box-shadow: 0px 12px 22px rgba(0, 94, 255, .35);
        }

        .loading-text {
          margin-top: 12px;
          color: #005eff;
          font-weight: 600;
        }

        .success-text {
          margin-top: 12px;
          color: green;
          font-weight: 600;
        }

        .faq-box {
          background: #f4f7ff;
          padding: 18px;
          border-left: 4px solid #005eff;
          border-radius: 12px;
          margin-bottom: 15px;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      {/* ⭐ BANNER */}
      <div className="banner">
        <h1>Warehousing & Storage Solutions</h1>
      </div>

      {/* ⭐ CONTENT SECTION */}
      <section className="section">
        <div className="container">

          {/* ⭐ OVERVIEW */}
          <div className="glass-card">
            <h2 className="title">Secure, Scalable & Technology-Driven Warehousing</h2>

            <p className="text">
              SWIFTSHIP provides world-class warehousing & storage solutions designed for businesses 
              that require reliable, secure and scalable logistics infrastructure.
              <br /><br />
              Our U.S.-based warehouses are equipped with modern storage technology, real-time inventory 
              systems, advanced safety controls, and 24/7 surveillance — ensuring your products remain 
              safe, organized and ready to ship anytime.
            </p>

            <p className="text">
              Whether you're a growing e-commerce brand, wholesale supplier, importer, manufacturer, 
              subscription business, or enterprise-level distributor — our warehousing network is 
              engineered to support your operations with accuracy, transparency, and efficiency.
              <br />
              From pallet storage to full 3PL fulfillment, SWIFTSHIP delivers a complete logistics 
              ecosystem designed to grow with your business.
            </p>
          </div>

          {/* ⭐ FEATURES */}
          <h2 className="title">Why Our Warehousing Stands Out</h2>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Climate-Controlled Storage</h5>
            <p className="text">
              Ideal for cosmetics, electronics, pharmaceuticals, supplements and sensitive items that 
              require stable temperature and humidity.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Pallet Storage & Bulk Inventory Solutions</h5>
            <p className="text">
              Perfect for distributors, manufacturers and wholesale suppliers managing large-scale 
              inventory across multiple U.S. regions.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Advanced Inventory Management (WMS)</h5>
            <p className="text">
              Our Warehouse Management System provides real-time SKU visibility, automated stock alerts, 
              order tracking, movement logs & analytics.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Secure Storage with 24/7 CCTV</h5>
            <p className="text">
              Your products are protected with high-security cameras, restricted access zones, 
              fire-suppression systems & monitored check-in/out protocols.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Kitting, Labeling & Custom Packaging</h5>
            <p className="text">
              We offer custom packaging services including bundling, labeling, repacking, and 
              subscription-box assembly at scale.
            </p>
          </div>

          <div className="feature-box">
            <h5 className="fw-bold">✔ Seamless Integration with Fulfillment</h5>
            <p className="text">
              Your stored inventory can be picked, packed and shipped same-day through our 3PL 
              fulfillment centers — all under one roof.
            </p>
          </div>

          {/* ⭐ INDUSTRIES */}
          <h2 className="title mt-5">Industries We Support</h2>

          <ul className="text">
            <li>✔ E-Commerce Brands</li>
            <li>✔ Importers & Exporters</li>
            <li>✔ Wholesale & Distribution</li>
            <li>✔ Retail & Marketplace Sellers</li>
            <li>✔ Pharmaceutical & Medical Suppliers</li>
            <li>✔ Tech & Electronics</li>
            <li>✔ Automotive Parts</li>
            <li>✔ Subscription Box Companies</li>
          </ul>

          {/* ⭐ FAQ */}
          <h2 className="title mt-5">Frequently Asked Questions</h2>

          <div className="faq-box">
            <strong>Q: Do you offer pallet storage?</strong>
            <p className="text">Yes — both short-term and long-term pallet storage options available.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Can we visit the warehouse?</strong>
            <p className="text">Absolutely — scheduled visits & virtual tours are available.</p>
          </div>

          <div className="faq-box">
            <strong>Q: Do you manage returns?</strong>
            <p className="text">Yes — we inspect, restock or dispose items based on your policy.</p>
          </div>

          {/* ⭐ PREMIUM FORM */}
          <form className="warehouse-form" onSubmit={handleSubmit}>
            <h3 className="fw-bold mb-4">Request a Warehousing Quote</h3>

            <div className="row g-3">

              <div className="col-md-6">
                <label className="form-label">Full Name</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Phone Number</label>
                <input type="text" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Email Address</label>
                <input type="email" className="form-control-custom" required />
              </div>

              <div className="col-md-6">
                <label className="form-label">Storage Duration</label>
                <select className="form-select-custom" required>
                  <option value="">Select Duration</option>
                  <option>Short-Term (1–3 Months)</option>
                  <option>Medium-Term (3–12 Months)</option>
                  <option>Long-Term (1+ Year)</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Inventory Volume</label>
                <select className="form-select-custom" required>
                  <option value="">Select Volume</option>
                  <option>1–10 Pallets</option>
                  <option>10–50 Pallets</option>
                  <option>50–200 Pallets</option>
                  <option>200+ Pallets</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Do You Need Fulfillment?</label>
                <select className="form-select-custom" required>
                  <option value="">Select Option</option>
                  <option>Yes, full 3PL fulfillment</option>
                  <option>Only warehousing</option>
                  <option>Warehousing + Light assembly</option>
                </select>
              </div>

              <div className="col-12">
                <label className="form-label">Product Type</label>
                <textarea className="form-control-custom" rows="4" required></textarea>
              </div>

            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "Submit Request"}
            </button>

            {loading && <div className="loading-text">Please wait...</div>}
            {done && <div className="success-text">Your request has been submitted successfully!</div>}
          </form>

        </div>
      </section>
    </>
  );
}
